<template>
  <span>

    <TooltipTop
      v-if="level === null || level === -1"
      title="Keine Informationen zur Verfügbarkeit der Leistung"
    >
      🤔
    </TooltipTop>
    <TooltipTop
      v-if="level === 0"
      title="Stufe 0: Keine Informationen im Internet verfügbar"
    >
      📝
    </TooltipTop>
    <TooltipTop
      v-if="level === 1"
      title="Stufe 1: Informationen zum Antrag im Internet verfügbar"
    >
      ℹ️
    </TooltipTop>
    <TooltipTop
      v-if="level === 2"
      title="Stufe 2: Antragsgenerator mit Formular zum Ausdrucken im Internet verfügbar"
    >
      🖨️
    </TooltipTop>
    <TooltipTop
      v-if="level === 3"
      title="Stufe 3: Antrag im Internet verfügbar"
    >
      🌏
    </TooltipTop>
    <TooltipTop
      v-if="level === 4"
      title='Stufe 4: Antrag der "schnell" ausgefüllt werden kann, im Internet verfügbar'
    >
      🥳
    </TooltipTop>
  </span>
</template>

<script>
  import TooltipTop from './TooltipTop';
export default {
  props: ["level", "applicableLaws"],
  name: "OZGLevelEmoji",
  components: {TooltipTop},

};
</script>

<style scoped>
TooltipTop {
  cursor: help;
  display: inline;
}
</style>
